<template>
  <b-row class="w-100">
    <b-col class="text-center">
      <h4>
        <b-icon-cloud-upload-fill :variant="$route.name === 'Upload File' ? 'primary' : null"></b-icon-cloud-upload-fill><br />
        Upload
      </h4>
    </b-col>
    <b-col class="text-center center"><hr class="mt-4"></b-col>
    <b-col class="text-center">
      <h4>
        <b-icon-files :variant="$route.name === 'Mapping' ? 'primary' : null"></b-icon-files><br />
        Map Data
      </h4>
    </b-col>
    <b-col class="text-center center"><hr class="mt-4"></b-col>
    <b-col class="text-center">
      <h4>
        <b-icon :icon="icon" :variant="iconVariant"></b-icon><br />
        Review
      </h4>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { BIcon, BIconCheck2Square, BIconCloudUploadFill, BIconXSquare, BIconFiles, LayoutPlugin } from 'bootstrap-vue'
import { IntelligentMatchStatus } from '@/store'

Vue.use(LayoutPlugin)

@Component({
  components: {
    BIconCloudUploadFill,
    BIconXSquare,
    BIconCheck2Square,
    BIconFiles,
    BIcon
  }
})
export default class Status extends Vue {
  get icon (): string {
    if (this.$store.state.status === IntelligentMatchStatus.Failed) {
      return 'x-square'
    }

    return 'check2-square'
  }

  get iconVariant (): string | undefined {
    if (this.$store.state.status === IntelligentMatchStatus.Success) {
      return 'success'
    }

    if (this.$store.state.status === IntelligentMatchStatus.Failed) {
      return 'danger'
    }
  }
}
</script>

<style lang="scss">
.nav-item a {
  padding: 0;
}
.nav-text {
  padding: 0;
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}
</style>
